import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { JsonLd } from "./JsonLd";
import { breadcrumbSchema } from "../lib/schema";

export const Breadcrumbs = ({ items }) => {
  return (
    <>
      <JsonLd data={breadcrumbSchema(items)} />
      <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="mb-7">
        <ol className="flex flex-wrap items-center gap-1.5 text-xs font-medium">
          <li>
            <Link
              to={"/"}
              data-testid="breadcrumb-home"
              className="text-charcoal/45 hover:text-tan transition-colors"
            >
              {"Home"}
            </Link>
          </li>
          {items.map((item, i) => {
            const last = i === items.length - 1;
            return (
              <li key={item.to} className="flex items-center gap-1.5">
                <ChevronRight size={12} strokeWidth={1.5} className="text-gold" />
                {last ? (
                  <span aria-current="page" className="text-charcoal/70">
                    {item.label}
                  </span>
                ) : (
                  <Link
                    to={item.to}
                    data-testid={`breadcrumb-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="text-charcoal/45 hover:text-tan transition-colors"
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
};
